export default __webpack_public_path__ + "static/media/carbon-flow-shema.0a0e8131.jpg";